import React from 'react';
import { Link } from 'react-router-dom';

import { paths } from '../../../../constants';
import { getClickAttrs } from '../../Analytics/gtag';
import { navigationIDs } from '../../Analytics/testIDConfig';

import styles from '../header.scss';

const DesktopPowerButtons = ({ isPowered, hasPastDueSubscription, hasActiveClubPower, onClick, isActive }) => {
    // A member powered by an active club membership stays powered through the
    // personal-subscription past-due window, so don't prompt them to resume it.
    const showResumePower = hasPastDueSubscription && !hasActiveClubPower;
    const showPowerPerks = (isPowered || hasActiveClubPower) && !showResumePower;
    const showGetPower = !isPowered && !hasActiveClubPower && !showResumePower;

    return (
        <div className={`${styles.powerWrapper}`}>
            <div className={`${styles.power}`}>
                {showResumePower && (
                    <Link
                        className={'btn-flex btn btn-primary'}
                        to="/subscriptions"
                        {...getClickAttrs({
                            category: 'Resume Power',
                            context: 'Power Perks Nav Top Resume Power Button Click',
                            location: 'Header Nav Top',
                            testid: `${navigationIDs.startPower.component}-${navigationIDs.startPower.location}-${navigationIDs.startPower.id}`,
                        })}
                    >
                        RESUME POWER
                    </Link>
                )}
                {showPowerPerks && (
                    <div className={`${styles.navLink} ${isActive ? 'active' : ''}`}>
                        <Link
                            className="underline clickable"
                            to={paths.powerPerks}
                            onClick={onClick}
                            {...getClickAttrs({
                                category: 'Power Perks',
                                context: 'Power Perks Nav Top Power Active Entrypoint Click',
                                location: 'Header Nav Top',
                                testid: `${navigationIDs.power.component}-${navigationIDs.power.location}-${navigationIDs.power.id}`,
                            })}
                        >
                            Power Perks
                        </Link>
                    </div>
                )}
                {showGetPower && (
                    <Link
                        className={styles.powerButton}
                        to="#"
                        onClick={onClick}
                        {...getClickAttrs({
                            category: 'Power Upgrade',
                            context: 'Power Perks Nav Top Start Power Button Click',
                            location: 'Header Nav Top',
                            testid: `${navigationIDs.startPower.component}-${navigationIDs.startPower.location}-${navigationIDs.startPower.id}`,
                        })}
                    >
                        Get Power
                    </Link>
                )}
            </div>
        </div>
    );
};

export default DesktopPowerButtons;
